import {
  chakra,
  forwardRef,
  type TableFooterProps as ChakraTfootProps,
} from '@chakra-ui/react';

import { useTableStyles } from '../TableStylesContext';

export type TfootProps = ChakraTfootProps;

export const Tfoot = forwardRef<TfootProps, 'tfoot'>((props, ref) => {
  const { tfoot: tfootStyles } = useTableStyles() ?? {};

  return <chakra.tfoot {...props} ref={ref} __css={tfootStyles} />;
});
